import React, { Fragment } from 'react';

import { Loader } from '@thinknet-gmbh/platform-common-ui';

import { PayrollAccountingDatevTable } from '../payroll-accounting-datev-table';

import { useGetPayrollAccounting } from 'src/hooks/payroll-accounting/get-payroll-accounting.hook';

import { generateTableData } from '../../../payroll-accounting.helpers';

import {
  IDatevPayrollAccountingFilters,
  IPayrollAccountingCollectionItem,
} from '../../../payroll-accounting.interfaces';


const PayrollAccountingDatevList = ({ filter }: { filter: IDatevPayrollAccountingFilters }) => {
  const { collection, loading } = useGetPayrollAccounting({
    filter,
  });

  const tableData = generateTableData(filter?.year || 0);

  const completeData = tableData.map(el => {
    const data = collection?.find(
      ({ _id }: IPayrollAccountingCollectionItem) => _id === el.monthNumber
    );
    if (data) {
      return { ...el, ...data.item };
    } else return el;
  });

  if (loading) {
    return <Loader />;
  }

  return (
    <Fragment>
      <PayrollAccountingDatevTable dataSource={completeData} filters={filter} />
    </Fragment>
  );
};

export default PayrollAccountingDatevList;
